import { object, string } from "yup";

export const ForgetPasswordValidation = object({
  email: string()
    .email("auth_should_be_valid_email")
    .required("field_should_have_value"),
});
